export const DeleteConfirmConsts = {
  TITLE: `Delete Material`,
  MODAL_WITH: "46.875rem",
  MESSAGE: `This material will be permanently deleted. Are you sure you want to proceed?`,
  REASON_LABEL: "Reason",
  REASON_PLACEHOLDER: "Enter delete reason",
  REASON_NAME: "archiveReason",
  DELETE_SUCCESS: `material deleted successfully`,
};
